import { useLocation, useNavigate, useParams } from "react-router-dom";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { Toaster } from "react-hot-toast";

import FolderContentComponent from "./components/folder-content";
import TableSection from "./components/table-section";
import CreateClientModal from "../clients/components/create-modal";
import { useEffect, useState } from "react";
import ClientAPI from "../../../services/api/clients.api";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../services/atoms/auth.atoms";

const ClientsDetails = () => {
  let { state } = useLocation();
  const { id: paramId } = useParams();

  let navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState()
  const user = useRecoilValue(userAtom)

  const handleOpenModal = () => setOpen(!open);

  const getDetailClient = async(id)=>{
    const clientDetail = await ClientAPI.findClient(id)
    clientDetail && setDetails(clientDetail.data)

  }

  const clientId = state?.client?.id || paramId;

  useEffect(()=>{
    if (!state?.client && clientId) {
      ClientAPI.findClient(clientId).then((res) => {
        if (res?.data) {
          setDetails(res.data);
          navigate(window.location.pathname, { replace: true, state: { client: res.data } });
        }
      });
    } else if (clientId) {
      getDetailClient(clientId)
    }
  }, [open, clientId])

  return (
    <div className="gm-clients-details-container">
      <Toaster />
      {state?.client &&
        <CreateClientModal
          open={open}
          toggle={handleOpenModal}
          isCreate={false}
          dataEdit={state?.client}
          getDetailClient={getDetailClient}
        />
      }
      {(details || state?.client) && (
        <FolderContentComponent
          client={details || state?.client}
          isSuperAdmin={Boolean(user?.data?.isSuperAdmin)}
          actions={user?.data?.isSuperAdmin && (
            <button type="button" className="gm-secondary-button" onClick={handleOpenModal}>
              <HiOutlinePencilSquare size={16} /> Editar cliente
            </button>
          )}
        />
      )}
      {state?.client &&
        <TableSection navigate={navigate} client={state?.client || null} onTestSent={() => getDetailClient(state.client.id)} />
      }
    </div>
  );
}

export default ClientsDetails;